import { AHIcon, Box, TouchableBox, useTheme } from "arkh";
import Color from "color";
import React from "react";
import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  editOverlayContainer: {
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
  },
});

export const PLUCategoryItemEditOverlay = React.memo(
  InnerPLUCategoryItemEditOverlay
);

function InnerPLUCategoryItemEditOverlay(props: { onPress(): void }) {
  const theme = useTheme();
  return (
    <TouchableBox style={styles.editOverlayContainer} onPress={props.onPress}>
      <Box
        spaceHorizontal="medium"
        cornerRadius="medium"
        style={{
          flex: 1,
          backgroundColor: Color(theme.background).alpha(0.9).toString(),
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <AHIcon type="edit" color="primary" size="medium" />
      </Box>
    </TouchableBox>
  );
}
